import { Router, ActivatedRoute } from '@angular/router';
import { GlobalPropertiesService } from '../core.module/services/global-properties.service';
import { Component, OnInit, ViewContainerRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { DataURLS } from '../shared/base.url';
import { LoggerService, LoopBackAuth } from '../shared/sdk/services';
import { OfferCodeApi } from '../shared/sdk/services/custom/OfferCode';

import { OfferCode } from '../shared/sdk/models/OfferCode';
import { LimitedTimeOfferApi } from '../shared/sdk/services/custom/LimitedTimeOffer';
import { FireLoopRef } from '../shared/sdk';
import { LimitedTimeOffer } from '../shared/sdk/models/LimitedTimeOffer';
import { RealTime } from '../shared/sdk/services/core/real.time';
import { LoopBackConfig } from '../shared/sdk/index';
import { Observable } from 'rxjs/Observable';

import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-claim-page',
  templateUrl: './claim-page.component.html',
  styleUrls: ['./claim-page.component.css']
})
export class ClaimPageComponent implements OnInit {
  // @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  public ltoRef: FireLoopRef<LimitedTimeOffer>;

  public claimForm: FormGroup;

  public appGlobal = this.globalPropertiesService.appGlobal;
  public email: string = null;
  public code: string;
  public codeReceived: boolean;

  constructor(
    private globalPropertiesService: GlobalPropertiesService,
    private toastrService: ToastrService,
    private logger: LoggerService,
    private fb: FormBuilder,
    private realTime: RealTime,
    private ltoApi: LimitedTimeOfferApi,
    private offerCodeApi: OfferCodeApi,
    private changeDetectorRef: ChangeDetectorRef

  ) {
    LoopBackConfig.setBaseURL(DataURLS.BASE_URL);
    LoopBackConfig.setApiVersion(DataURLS.API_VERSION);

    this.claimForm = this.fb.group({
      'email': [null, Validators.required],
      'pincode': [null, Validators.required]
    });
  }

  ngOnInit() {

  }

  sendClaimNumber(formData: any) {

    this.ltoApi.processClaim(formData.pincode, formData.email)
      .subscribe((data) => {
        this.toastrService.clear();
        this.logger.info(`Great news, Code Received! = '${data.result.code}'`);
        this.code = data.result.code;
        // localStorage.setItem('resetEmail', null); // erase reset email
        this.codeReceived = true;
        this.changeDetectorRef.detectChanges();
      }, err => {
        this.toastrService.clear();
        this.toastrService.error('Sorry, that code is not vaild', 'Oops!', { positionClass: 'toast-top-full-width', timeOut: 5000 });
        this.logger.error(`code not valid error: ${err.message}`);
      });


  }

}



// WEBPACK FOOTER //
// ./src/app/claim-page/claim-page.component.ts